import React from "react";
import { connect } from "react-redux";
import { ResetPinPopupButton } from "./popup-menu-buttons/reset-pin-popup-button.component";
import { ReplaceCardPopupButton } from "./popup-menu-buttons/replace-card-popup-button.component";
import { TravelExemptionPopupButton } from './popup-menu-buttons/travel-exemption-popup-button.component';
import { callGetTravelExemptionEligibility } from "../../../../actions/cardControls.actions";
import Show from "../../../../utils/show.component";

export const CardControlPopupMenuComponent = (props) => {
  return (
    <div className="row px-2 pt-1" style={{ position: "relative" }}>
      <button
        className="ml-auto mt-0 p-0 px-2"
        style={{ backgroundColor: "white" }}
        onClick={props.togglePopupMenu}
        data-e2e-id={"cardControlMenuButton"}
        disabled={!props.EligibleForDebitReplacement}
      >
        <div className="d-flex">
          <i class="material-icons">more_horiz</i>
        </div>
      </button>
      <div
        className="auth-card-popup-menu"
        style={{
          display: props.showPopupMenu ? "" : "none",
        }}
      >
        <ul className="p-0 m-0" style={{ listStyleType: "none" }}>
          <ResetPinPopupButton {...props} />
          <ReplaceCardPopupButton {...props} />
          <Show condition={props.EligibleForTravelExemption === true}>
            <TravelExemptionPopupButton {...props} />
          </Show>
        </ul>
      </div>
    </div>
  );
};
const mapDispatchToProps = {
  callGetTravelExemptionEligibility,
};

const mapStateToProps = null;

export const CardControlPopupMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(CardControlPopupMenuComponent);



// WEBPACK FOOTER //
// ./src/components/card-controls/card/menu/card-control-popup-menu.component.js